import React from 'react';
import './Recap.css';

const Recap = () => {
    return (
        <div className="recap-container">
            <div className="recap-left">
                <h2>2023 Summit Recap</h2>
                <p>
                    Here is a recap of the 2023 Africa Mining Summit Investment, where industry leaders and stakeholders came together to celebrate and shape the future of African mining.
                </p>
            </div>
            <div className="recap-right">
                <div className="video-container">
                    <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/NvZeTwnYVP8" // Replace with your video ID
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default Recap;
